export function filterDeliveryRequestsByInternalTransfers(requests) {
  const seenTransferIds = new Set()
  const filteredRequests = []

  for (const request of requests) {
    if (!request.is_internal_transfer) {
      // Always include non-internal transfers
      filteredRequests.push(request)
    } else {
      // Include only the first occurrence of each internal_transfer_id
      if (!seenTransferIds.has(request.internal_transfer_id)) {
        seenTransferIds.add(request.internal_transfer_id)
        filteredRequests.push(request)
      }
    }
  }

  return filteredRequests
}
